import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { Notice } from "./ui";

/**
 * Voided vouchers are in no book and not in the Caja (plan 024): says how many were left out and
 * links to them, so nobody wonders why a total differs from ARCA.
 */
export function VoidedNotice({
  companyId,
  periodo,
  anulados,
}: {
  companyId: string;
  periodo: string;
  anulados: { compra: number; venta: number } | undefined;
}) {
  if (!anulados || anulados.compra + anulados.venta === 0) return null;
  const parts = (["compra", "venta"] as const).flatMap((dir) => {
    const n = anulados[dir];
    if (n === 0) return [];
    const label = `${n} ${dir === "compra" ? "compra" : "venta"}${n === 1 ? "" : "s"} anulada${n === 1 ? "" : "s"}`;
    return [
      <Link
        key={dir}
        to="/empresas/$companyId/comprobantes"
        params={{ companyId }}
        search={{ periodo, dir, estado: "anulados" }}
        className="font-medium underline"
      >
        {label}
      </Link>,
    ];
  });
  return (
    <Notice tone="info">
      {parts.reduce<ReactNode[]>((acc, part, i) => (i === 0 ? [part] : [...acc, " y ", part]), [])}{" "}
      en el período: no se incluyen.
    </Notice>
  );
}
